import { ActionIcon, Menu } from "@mantine/core";
import { IconLanguage } from "@tabler/icons-react";
import { observer } from "mobx-react-lite";
import { uiStore } from "@/mobx/rootStore";

/**
 * Selector de idioma (es/en). Reutilizable en layouts privados y páginas públicas.
 * @param {object} props - Props extra para el ActionIcon disparador (ej. `ml="auto"`).
 */
export const LanguageSwitcher = observer(function LanguageSwitcher({ ...actionIconProps }) {
	return (
		<Menu position="bottom-end" shadow="md" width={200}>
			<Menu.Target>
				<ActionIcon variant="subtle" size="md" {...actionIconProps}>
					<IconLanguage />
				</ActionIcon>
			</Menu.Target>

			<Menu.Dropdown>
				<Menu.Item
					leftSection="🇪🇸"
					rightSection={uiStore.language === "es" ? "✓" : null}
					onClick={() => uiStore.setLanguage("es")}
				>
					Español
				</Menu.Item>
				<Menu.Item
					leftSection="🇬🇧"
					rightSection={uiStore.language === "en" ? "✓" : null}
					onClick={() => uiStore.setLanguage("en")}
				>
					English
				</Menu.Item>
			</Menu.Dropdown>
		</Menu>
	);
});
